<template>
  <div class="row">
    <div class="col-12 active">
      <div class="card active">
        <div class="card-body mini-nav bg-primary pt-2 pb-3 active ">
          <nav class="navbar navbar-expand-md navbar navbar-dark bg-primary py-2 active">

            <button
                class="navbar-toggler btn btn-sm px-3 font-size-16 header-item waves-effect h-auto text-primary"
                type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
                aria-controls="navbarNavAltMarkup" aria-expanded="false"
                aria-label="Toggle navigation">
              <span class="mdi mdi-menu"></span>
            </button>

            <div class="collapse navbar-collapse justify-content-between active scrollable-navbar"
                 id="navbarNavAltMarkup">
              <div class="navbar-nav flex-nowrap">
                <router-link v-if="getRight('DASHBOARD')" :to="{name: 'cert-biz-stats'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Dashboard</router-link>
                <router-link v-if="getRight('DASHBOARD')" :to="{name: 'sbp-performance-dashboard'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Performance</router-link>
                <router-link v-if="getRight('DASHBOARD')" :to="{name: 'business-type-analytics'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Business Types</router-link>
                <router-link v-if="getRight('SBP VALIDATION PAGE')" :to="{name: 'pending-validation'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Pending Validation</router-link>
                <router-link v-if="getRight('SBP INSPECTION PAGE')" :to="{name: 'pending-inspection'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Pending Inspection</router-link>
                <router-link v-if="getRight('SBP APPROVAL PAGE')" :to="{name: 'pending-approval'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Pending Approval</router-link>
                <router-link v-if="getRight('DECLINED')" :to="{name: 'declined'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Declined</router-link>
                <router-link v-if="getRight('APPROVED')" :to="{name: 'approved'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Approved</router-link>
                <router-link v-if="getRight('APPROVED')" :to="{name: 'expired'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Expired</router-link>
                <router-link v-if="getRight('UNPAID SPBs')" :to="{name: 'unpaid-sbp'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Unpaid SBPs</router-link>
                <router-link v-if="getRight('PENDING BILLS')" :to="{name: 'sbp-unpaid-bills'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Invoices</router-link>
                <router-link v-if="getRight('SBP RECEIPTS')" :to="{name: 'sbp-paid-bills'}" active-class="mm-active" class="nav-item nav-link text-nowrap">SBP Receipt</router-link>
                <router-link v-if="getRight('MAP VIEW')" :to="{name: 'sbp-map'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Map View</router-link>
                <router-link v-if="getRight('MAP VIEW')" :to="{name: 'sbp-map-filter'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Sub County Map View</router-link>
                <router-link v-if="getRight('BUSINESS REGISTRY')" :to="{name: 'business-register'}" active-class="mm-active" class="nav-item nav-link text-nowrap">Business Registry</router-link>

              </div>

              <a v-if="getRight('BULK INVOICING')" @click="gotTo('previous-register')" href="javascript: void(0);" title="create invoice s in bulk" type="button" class="btn btn-success waves-effect waves-light text-uppercase text-nowrap ms-3">
                <i class="bx bx-check-double font-size-16 align-middle me-2"></i> Bulk Invoicing Manager
              </a>

            </div>


          </nav>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {getRight} from "@/api";

export default {
  name: "ToolBar",
  data() {
    return {
      dashboard: true,
      validation: true,
      inspection: true,
      approval: true,
      declined: true,
      approved: true,
      paidSbp: true,
      unpaidSbp: true,
      unpaidBills: true,
      sbpPaidBills: true,
      sbpMap: true,
      selectedSub: null,
    }
  },
  methods:{
    getRight(type){
      return getRight(type)
    },
    mounted() {

      this.selectedSub = sessionStorage.getItem("selectedSub")

    },
    gotTo(route){
      this.$router.push(route);
      sessionStorage.setItem("selectedSub",route)
      this.selectedSub = route
    }
  }
}
</script>

<style scoped>
/* Make the navbar scrollable horizontally */
.scrollable-navbar {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  scrollbar-width: thin; /* Firefox */
}

/* Style for webkit browsers (Chrome, Safari, Edge) */
.scrollable-navbar::-webkit-scrollbar {
  height: 6px;
}

.scrollable-navbar::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

.scrollable-navbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
}

.scrollable-navbar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Prevent navbar items from wrapping */
.navbar-nav.flex-nowrap {
  flex-wrap: nowrap !important;
}

/* Ensure nav links have proper spacing and don't break */
.navbar-nav .nav-link {
  padding: 0.5rem 1rem;
  white-space: nowrap;
}

/* Active link styling */
.navbar-nav .nav-link.mm-active {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

/* Smooth scrolling */
.scrollable-navbar {
  scroll-behavior: smooth;
}

/* Optional: Add fade effect on edges to indicate scrollability */
.scrollable-navbar::after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  width: 50px;
  height: 100%;
  background: linear-gradient(to left, var(--bs-primary), transparent);
  pointer-events: none;
}
</style>